/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable consistent-return */
import { useEffect } from 'react'

type Ref = React.RefObject<HTMLElement>

type UseClickOutsideWithExceptionsOptions = {
  refs: Ref[]
  onClickOutside: () => void
  exceptionSelectors?: string[]
  disabled?: boolean
  eventType?: 'pointerdown' | 'mousedown' | 'click'
}

export function useClickOutsideWithExceptions({
  refs,
  onClickOutside,
  exceptionSelectors = [],
  disabled = false,
  eventType = 'pointerdown'
}: UseClickOutsideWithExceptionsOptions) {
  useEffect(() => {
    if (disabled) return

    const handle = (event: Event) => {
      const target = event.target as Node | null
      if (!target) return

      const isInsideRefs = refs.some(ref => {
        const el = ref.current
        return el ? el === target || el.contains(target) : false
      })
      if (isInsideRefs) return

      let isInsideExceptions = false
      if (target instanceof Element) {
        isInsideExceptions = exceptionSelectors.some(sel => target.closest(sel))
      } else {
        const path = (event as any).composedPath?.() as Node[] | undefined
        if (path) {
          isInsideExceptions = exceptionSelectors.some(sel =>
            path.some(n => n instanceof Element && (n as Element).matches(sel))
          )
        }
      }
      if (isInsideExceptions) return

      onClickOutside()
    }

    document.addEventListener(eventType, handle, true)

    return () => {
      document.removeEventListener(eventType, handle, true)
    }
  }, [onClickOutside, disabled, eventType, refs, exceptionSelectors])
}
